<template>
  <c-button
    left-icon="download"
    variation="solid"
    background="brand.beige"
    border-color="brand.beige"
    @click="onDownloadParcelLabel()"
  >
    {{ $t("productReturn.pastReturns.parcelLabel") }}
  </c-button>
</template>

<script lang="ts">
import { IRootState } from "@iloq/shared";
import { CButton } from "@chakra-ui/vue";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  components: {
    CButton,
  },
  name: "RMADownloadParcel",
  props: {
    returnId: {
      type: String,
      required: true,
    },
    returnType: {
      type: String,
      required: true,
    },
  },
  computed: mapState({
    user: (state: unknown) => (state as IRootState).user!,
  }),
  methods: {
    onDownloadParcelLabel(): void {
      const email = this.user.email;
      this.$store.dispatch("fetchDownloadToken").then((downloadToken) => {
        const url = `/api/v1/returns/parcelLabels/${email}/${this.returnId}?auth_token=${downloadToken}&return_type=${this.returnType}`;
        window.open(url, "_blank");
      });
    },
  },
});
</script>
